import {LitElement, css, html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {ContextConsumer} from '@lit/context';
import {artistContext } from '../context/artist-context.ts';
import {repeat} from 'lit/directives/repeat.js';
import {animate, fadeIn} from '@lit-labs/motion';
@customElement('artist-sort')
export class ArtistSort extends LitElement {

  @state()
  private sorts?: any = []

  @state()
  private label?: string = ''

  connectedCallback() {
    super.connectedCallback()
    new ContextConsumer(this, {
      context: artistContext,
      subscribe: true,
      callback: ({data}) => {
        if (data) {
          this.sorts = this.transformFilterCollectionToSorts(data)
          this.requestUpdate();
        }
      },
    });
  }
  createRenderRoot() {
    return this;
  }

  private _onChange(filter: any) {
    const options = {
      detail: filter.apiLink,
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistFilterChange', options));
  }

  private transformFilterCollectionToSorts(data:any) {
    let sorts:any = []
    const filterCollections = data.filterCollections
    filterCollections?.map((filterCollection:any) => {
      sorts = filterCollection.sortingSet.sorts
      this.label = filterCollection.sortingSet.label
    })
    return sorts
  }

  render() {
    return html`
        <z3-dropdown closeonclickinside label="${this.label}" autowidth="false">
            ${repeat(this.sorts, (filter:any) => filter.identifier, (filter, i) => html`
                <div class="filter" ${animate({
                keyframeOptions: {
                    duration: 500,
                    delay: (i * 500) / this.sorts.length,
                    fill: 'both',
                },
                properties: ['opacity'],
                in: fadeIn
            })}>
                    <label class="checkbox ${filter.enabled ? '' : 'disabled'}">
                        <input type="checkbox"
                               .checked="${filter.selected}"
                               .disabled="${!filter.enabled}"
                               @change="${() => this._onChange(filter)}">
                        <span>${filter.label}</span>
                    </label>
                </div>
            `)}
        </z3-dropdown>        
    `}

  static styles = css`
      :host {
      }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-sort': ArtistSort
  }
}
